import classNames from 'classnames'

const PrimaryCard = ({
  children,
  containerClass = '',
  childClass = 'p-6',
}: {
  children: React.ReactNode
  containerClass?: string
  childClass?: string
}) => {
  return (
    <div className={classNames('bg-brand-white rounded-lg', containerClass)}>
      <div className={childClass}>{children}</div>
    </div>
  )
}

export default PrimaryCard
